export const eventNames = {
	// LOGIN EVENTS
	LOGIN_ATTEMPT: "login_attempt",
	LOGIN_SUCCESS: "login_success",
	LOGIN_FAILED: "login_failed",

	// REGISTRATION EVENTS
	SIGNUP_ATTEMPT: "signup_attempt",
	SIGNUP_SUCCESS: "signup_success",
	SIGNUP_FAILED: "signup_failed",

	// DEPOSIT EVENTS
	DEPOSIT_ATTEMPT: "deposit_attempt",
	DEPOSIT_PENDING: "deposit_pending",
	DEPOSIT_SUCCESS: "deposit_success",
	DEPOSIT_FAILED: "deposit_failed",
	FIRST_DEPOSIT: "first_deposit",

	// WITHDRAW EVENTS
	WITHDRAW_ATTEMPT: "withdraw_attempt",
	WITHDRAW_PENDING: "withdraw_pending",
	WITHDRAW_SUCCESS: "withdraw_success",
	WITHDRAW_FAILED: "withdraw_failed",

	// SPORTBOOK_BET EVENTS
	SPORTSBOOK_BET_PLACEMENT_ATTEMPT: "sportsbook_bet_placement_attempt",
	SPORTSBOOK_BET_PLACEMENT_SUCCESS: "sportsbook_bet_placement_success",
	SPORTSBOOK_BET_PLACEMENT_FAILED: "sportsbook_bet_placement_failed",

	// VIRTUALS_BET_PLACEMENT EVENTS
	VIRTUALS_BET_PLACEMENT_ATTEMPT: "virtuals_bet_placement_attempt",
	VIRTUALS_BET_PLACEMENT_SUCCESS: "virtuals_bet_placement_success",
	VIRTUALS_BET_PLACEMENT_FAILED: "virtuals_bet_placement_failed",

	// SHIKISHA_BET_PLACEMENT EVENTS
	SHIKISHA_BET_PLACEMENT_ATTEMPT: "shikisha_bet_placement_attempt",
	SHIKISHA_BET_PLACEMENT_SUCCESS: "shikisha_bet_placement_success",
	SHIKISHA_BET_PLACEMENT_FAILED: "shikisha_bet_placement_failed",

	// JACKPOT_BET_PLACEMENT EVENTS
	JACKPOT_BET_PLACEMENT_AUTO_PICK: "jackpot_bet_placement_autopick",
	JACKPOT_BET_PLACEMENT_ATTEMPT: "jackpot_bet_placement_attempt",
	JACKPOT_BET_PLACEMENT_SUCCESS: "jackpot_bet_placement_success",
	JACKPOT_BET_PLACEMENT_FAILED: "jackpot_bet_placement_failed",

	// BETSLIP EVENT
	BETSLIP_ADD: "Bet_sportsbook_bets_add",
	BETSLIP_REMOVE: "Bet_sportsbook_bets_remove",
	BETSLIP_CLEAR: "Bet_sportsbook_bets_clear",

	// CASINO EVENTS
	CASINO_PLAY: "casino_play",
	CASINO_CLOSE: "casino_close",

	// IFRAME EVENTS
	IFRAME_CLICK: "iframe_game_click",

	// PROMOTIONAL EVENTS
	PROMO_CLICK: "promo_click",

	// GENERAL EVENTS
	GENERAL_PAGEVIEW: "page_view",
	GENERAL_LANGUAGE_CODE: "language",
	GENERAL_THEME: "theme_mode",
	GENERAL_SESSION_START: "SESSION_START",
	CUSTOM_SEARCH: "custom_search",
	SHARE_A_BET: "share_bet",
	FILTER_APPLIED: "filter_applied",
	PRINT_MATCHES: "print_matches",
	WATCH: "watch",
	RECOMMENDATIONS: "recommendations",
	CLICK_DOWNLOAD_ANDROID: "click_download_android",
	CLICK_DOWNLOAD_IOS: "click_download_ios",
	CLICK_EMAIL_LINK: "click_email_link",
	EXPERIMENT_SEEN: "experiment_seen",
};

export const registrationCategories = {
	attempt: {
		event: eventNames.SIGNUP_ATTEMPT,
		eventCategory: "Registration",
		parameters: ["mobile", "remember", "utmSource", "utmMedium", "utmCampaign"],
	},
	success: {
		event: eventNames.SIGNUP_SUCCESS,
		eventCategory: "Registration",
		parameters: [
			"mobile",
			"user_id",
			"affiliateID",
			"regDate",
			"utmSource",
			"utmMedium",
			"utmCampaign",
			"event_id",
			"value",
			"currency",
		],
	},
	failed: {
		event: eventNames.SIGNUP_FAILED,
		eventCategory: "Registration",
		parameters: ["mobile", "failRegReason"],
	},
};

export const loginCategories = {
	attempt: {
		event: eventNames.LOGIN_ATTEMPT,
		eventCategory: "Login",
		parameters: ["mobile", "remember", "utmSource", "utmMedium", "utmCampaign"],
	},
	success: {
		event: eventNames.LOGIN_SUCCESS,
		eventCategory: "Login",
		parameters: [
			"mobile",
			"user_id",
			"affiliateID",
			"userBalance",
			"bonusBalance",
			"pointsBalance",
			"event_id",
		],
	},
	failed: {
		event: eventNames.LOGIN_FAILED,
		eventCategory: "Login",
		parameters: ["mobile", "failRegReason"],
	},
};

export const depositCategories = {
	attempt: {
		event: eventNames.DEPOSIT_ATTEMPT,
		eventCategory: "Deposit",
		parameters: [
			"mobile",
			"user_id",
			"wallet_balance",
			"depositAmount",
			"depositMethod",
		],
	},
	pending: {
		event: eventNames.DEPOSIT_PENDING,
		eventCategory: "Deposit",
		parameters: ["amount", "user_id", "currency", "event_id", "value"],
	},
	success: {
		event: eventNames.DEPOSIT_SUCCESS,
		eventCategory: "Deposit",
		parameters: [
			"mobile",
			"user_id",
			"wallet_balance",
			"depositAmount",
			"depositMethod",
			"isFirstDeposit",
			"message",
			"event_id",
			"value",
			"currency",
		],
	},
	failed: {
		event: eventNames.DEPOSIT_FAILED,
		eventCategory: "Deposit",
		parameters: [
			"mobile",
			"user_id",
			"wallet_balance",
			"depositAmount",
			"depositMethod",
			"message",
		],
	},
	first: {
		event: eventNames.FIRST_DEPOSIT,
		eventCategory: "Deposit",
		parameters: ["amount", "currency", "method", "event_id", "value"],
	},
};

export const withdrawCategories = {
	attempt: {
		event: eventNames.WITHDRAW_ATTEMPT,
		eventCategory: "Withdraw",
		parameters: [
			"mobile",
			"user_id",
			"wallet_balance",
			"withdrawAmount",
			"withdrawMethod",
		],
	},
	success: {
		event: eventNames.WITHDRAW_SUCCESS,
		eventCategory: "Withdraw",
		parameters: [
			"mobile",
			"user_id",
			"wallet_balance",
			"withdrawAmount",
			"withdrawMethod",
			"message",
		],
	},
	failed: {
		event: eventNames.WITHDRAW_FAILED,
		eventCategory: "Withdraw",
		parameters: ["amount", "currency", "message", "user_id"],
	},
};

export const sportsbookBetCategories = {
	attempt: {
		event: eventNames.SPORTSBOOK_BET_PLACEMENT_ATTEMPT,
		eventCategory: "sportsbook",
		parameters: ["betslip", "num_Of_Bets", "stake", "user_id", "bet_type"],
	},
	success: {
		event: eventNames.SPORTSBOOK_BET_PLACEMENT_SUCCESS,
		eventCategory: "sportsbook",
		parameters: [
			"betslip",
			"stake",
			"total_odds",
			"ticket_id",
			"ref",
			"user_id",
			"message",
			"bet_type",
			"event_id",
			"value",
			"currency",
		],
	},
	failed: {
		event: eventNames.SPORTSBOOK_BET_PLACEMENT_FAILED,
		eventCategory: "sportsbook",
		parameters: [
			"betslip",
			"num_Of_Bets",
			"stake",
			"bet_type",
			"user_id",
			"message",
		],
	},
};

export const virtualsBetCategories = {
	attempt: {
		event: eventNames.VIRTUALS_BET_PLACEMENT_ATTEMPT,
		eventCategory: "virtualsBet",
		parameters: ["betslip", "num_Of_Bets", "stake", "user_id", "bet_type"],
	},
	success: {
		event: eventNames.VIRTUALS_BET_PLACEMENT_SUCCESS,
		eventCategory: "virtualsBet",
		parameters: [
			"betslip",
			"stake",
			"total_odds",
			"user_id",
			"message",
			"bet_type",
			"event_id",
			"value",
			"currency",
		],
	},
	failed: {
		event: eventNames.VIRTUALS_BET_PLACEMENT_FAILED,
		eventCategory: "virtualsBet",
		parameters: [
			"betslip",
			"num_Of_Bets",
			"stake",
			"bet_type",
			"user_id",
			"message",
		],
	},
};

export const shikishaBetCategories = {
	attempt: {
		event: eventNames.SHIKISHA_BET_PLACEMENT_ATTEMPT,
		eventCategory: "shikishaBet",
		parameters: ["betslip", "num_Of_Bets", "stake", "user_id", "bet_type"],
	},
	success: {
		event: eventNames.SHIKISHA_BET_PLACEMENT_SUCCESS,
		eventCategory: "shikishaBet",
		parameters: [
			"betslip",
			"stake",
			"total_odds",
			"user_id",
			"message",
			"bet_type",
			"event_id",
			"value",
			"currency",
		],
	},
	failed: {
		event: eventNames.SHIKISHA_BET_PLACEMENT_FAILED,
		eventCategory: "shikishaBet",
		parameters: [
			"betslip",
			"num_Of_Bets",
			"stake",
			"bet_type",
			"user_id",
			"message",
		],
	},
};

export const jackpotsBetCategories = {
	autopick: {
		event: eventNames.JACKPOT_BET_PLACEMENT_AUTO_PICK,
		eventCategory: "jackpotsBet",
		parameters: ["bet_type", "pick"],
	},
	attempt: {
		event: eventNames.JACKPOT_BET_PLACEMENT_ATTEMPT,
		eventCategory: "jackpotsBet",
		parameters: ["betslip", "num_Of_Bets", "stake", "user_id", "bet_type"],
	},
	success: {
		event: eventNames.JACKPOT_BET_PLACEMENT_SUCCESS,
		eventCategory: "jackpotsBet",
		parameters: [
			"betslip",
			"stake",
			"jackpot_id",
			"combinations",
			"num_Of_Bets",
			"user_id",
			"bet_type",
			"message",
			"event_id",
			"value",
			"currency",
		],
	},
	failed: {
		event: eventNames.JACKPOT_BET_PLACEMENT_FAILED,
		eventCategory: "jackpotsBet",
		parameters: [
			"betslip",
			"num_Of_Bets",
			"stake",
			"bet_type",
			"combinations",
			"user_id",
			"message",
		],
	},
};

export const betSlipCategories = {
	add: {
		event: eventNames.BETSLIP_ADD,
		eventCategory: "betSlip",
		parameters: [
			"appName",
			"betType",
			"display",
			"matchId",
			"profileId",
			"betPick",
			"homeTeam",
			"awayTeam",
			"oddValue",
			"market",
			"startTime",
		],
	},
	remove: {
		event: eventNames.BETSLIP_REMOVE,
		eventCategory: "betSlip",
		parameters: [
			"appName",
			"betType",
			"display",
			"matchId",
			"profileId",
			"betPick",
			"homeTeam",
			"awayTeam",
			"oddValue",
			"market",
			"startTime",
		],
	},
	clear: {
		event: eventNames.BETSLIP_CLEAR,
		eventCategory: "betSlip",
		parameters: ["bet_slip_count"],
	},
};

export const casinoCategories = {
	casinoPlay: {
		event: eventNames.CASINO_PLAY,
		eventCategory: "Casino",
		parameters: [
			"mode",
			"gameName",
			"gameProvider",
			"gameCode",
			"category",
			"gameID",
		],
	},
	closeCasinoSession: {
		event: eventNames.CASINO_CLOSE,
		eventCategory: "Casino",
		parameters: ["gameName", "gameProvider"],
	},
};
export const betikaFastaCasinoCategories = {
	add: {
		event: eventNames.CASINO_PLAY,
		eventCategory: "Casino",
		parameters: ["event_name", "game_name", "game_position"],
	},
};

export const iframeCategories = {
	add: {
		event: eventNames.IFRAME_CLICK,
		eventCategory: "IframeGame",
		parameters: [
			"game_event",
			"game_mode",
			"game_provider",
			"game_category",
			"game_name",
			"game_bet",
			"game_bet_value",
			"game_bet_outcome",
		],
	},
};

export const generalCategories = {
	pageView: {
		event: eventNames.GENERAL_PAGEVIEW,
		eventCategory: "GeneralEvents",
		parameters: ["pageUrl", "isAuthenticated", "user_id"],
	},
	languageCodeChange: {
		event: eventNames.GENERAL_LANGUAGE_CODE,
		eventCategory: "GeneralEvents",
		parameters: ["lang"],
	},
	theme: {
		event: eventNames.GENERAL_THEME,
		eventCategory: "GeneralEvents",
		parameters: ["mode_selected"],
	},
	sessionStart: {
		event: eventNames.GENERAL_SESSION_START,
		eventCategory: "GeneralEvents",
		parameters: ["sessionID"],
	},
	promotionClick: {
		event: eventNames.PROMO_CLICK,
		eventCategory: "Promotional",
		parameters: ["promotion_name", "promotion_cta"],
	},
	customSearch: {
		event: eventNames.CUSTOM_SEARCH,
		eventCategory: "GeneralEvents",
		parameters: ["searchTerm"],
	},
	shareABet: {
		event: eventNames.SHARE_A_BET,
		eventCategory: "GeneralEvents",
		parameters: ["platform"],
	},
	watch: {
		event: eventNames.WATCH,
		eventCategory: "GeneralEvents",
		parameters: ["provider", "event", "parent_match_id"],
	},
	recommendations: {
		event: eventNames.RECOMMENDATIONS,
		eventCategory: "GeneralEvents",
		parameters: [
			"id",
			"home_team",
			"away_team",
			"market",
			"odd_key",
			"odd_value",
		],
	},
	clickEmailLink: {
		event: eventNames.CLICK_EMAIL_LINK,
		eventCategory: "GeneralEvents",
		parameters: ["emailId"],
	},
	filterApplied: {
		event: eventNames.FILTER_APPLIED,
		eventCategory: "GeneralEvents",
		parameters: ["filter_selection"],
	},
	printMatches: {
		event: eventNames.PRINT_MATCHES,
		eventCategory: "GeneralEvents",
		parameters: ["printType"],
	},
};

export const experimentCategories = {
	experimentSeen: {
		event: eventNames.EXPERIMENT_SEEN,
		eventCategory: "Experiments",
		parameters: [
			"experimentId",
			"variationId",
			"experimentName",
			"variationName",
			"browser",
			"utmSource",
			"utmMedium",
			"utmCampaign"
		],
	},
};
